import React from "react";

import CloseIcon from "@mui/icons-material/Close";
import { Box, Container, Divider, Modal, SxProps } from "@mui/material";

import { ShareContext } from "./context/share-context";
import { useShareContextHook } from "./context/use-share-context-hook";
import { InviteBox } from "./Invite-box/InviteBox";
import { ShareList } from "./Share-list/ShareList";

import "./ShareDialog.styles.scss";

const style: SxProps = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  backgroundColor: "#ffffff",
  borderRadius: "8px",
  padding: "0px 30px",
  maxWidth: "950px"
};

const headerStyles: SxProps = {
  gap: "5px",
  color: "#0a3142",
  height: "54px",
  padding: "0",
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-end"
};

export const ShareDialog: React.FC = () => {
  const shareContext = useShareContextHook();

  const getMaxWidth = () => {
    if (!shareContext.isShareStep && shareContext.globalDoc) return "650px";
    if (!shareContext.isShareStep) return "973px";
    if (!shareContext.dealId) return "550px";
    if (shareContext.isShareStep) return "900px";
  };

  return (
    <ShareContext.Provider value={shareContext}>
      <Modal open={shareContext.isModalOpen} onClose={shareContext.onClose}>
        <Container sx={{ ...style, maxWidth: getMaxWidth() }} maxWidth={false} disableGutters>
          <Box sx={headerStyles}>
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <span>{shareContext.modalTitle}</span>
              <CloseIcon sx={{ cursor: "pointer" }} onClick={shareContext.onClose} />
            </Box>
            <Divider
              sx={{
                height: "1px",
                width: "100%",
                backgroundColor: "#dae0e2",
                borderColor: "#dae0e2",
                borderBottomWidth: "1px"
              }}
            />
          </Box>
          <Container disableGutters>
            {shareContext.isShareStep && <InviteBox />}
            {shareContext.isMembersStep && <ShareList />}
          </Container>
        </Container>
      </Modal>
    </ShareContext.Provider>
  );
};
